import { createSlice } from "@reduxjs/toolkit";
import LocalStorageService from "../../common/services/LocalStorageService";

// Persisted per-device (not synced to the backend). Default light so existing
// users see no change until they explicitly opt into dark.
const saved = LocalStorageService.get("themeMode");

const themeSlice = createSlice({
  name: "theme",
  initialState: { mode: saved === "dark" ? "dark" : "light" },
  reducers: {
    toggleTheme(state) {
      state.mode = state.mode === "light" ? "dark" : "light";
      LocalStorageService.set("themeMode", state.mode);
    },
    setTheme(state, action) {
      state.mode = action.payload === "dark" ? "dark" : "light";
      LocalStorageService.set("themeMode", state.mode);
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
